"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7780],{

/***/ 30536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ BlockImageLink; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var component_dato_image_src = __webpack_require__(44674);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 56px;\n  box-sizing: border-box;\n  align-items: center;\n  padding-right: 24px;\n  padding-left: 24px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  p {\n    overflow: hidden;\n    width: 100%;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  width: ",
        ";\n  height: ",
        ";\n  max-height: 100%;\n  align-items: ",
        ";\n  border: ",
        ";\n  transition: 300ms;\n  &:hover {\n    box-shadow: 0px 18px 45px ",
        ";\n  }\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  @media screen and (max-width: 469px) {\n    width: 271px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}



const DescriptionBar = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-605a881f-0"
})(_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const Image = (0,styled_components_browser_cjs["default"])(component_dato_image_src/* DatoImage */.jt).withConfig({
    componentId: "sc-605a881f-1"
})(_templateObject1());
const Container = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-605a881f-2"
})(_templateObject2(), (props)=>props.size === "large" ? "288px" : props.size === "medium" ? "296px" : props.size === "x-small" ? "200px" : "288px", (props)=>props.size === "large" ? "266px" : props.size === "medium" ? "376px" : props.size === "x-small" ? "220px" : "321px", (props)=>props.mirrorX ? "flex-end" : "flex-start", (props)=>props.border ? "1px solid ".concat(lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]) : "none", lib_styles_src/* theme.palette.shadow.main */.rS.palette.shadow.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/block-image-link.tsx






const BlockImageLink = (param)=>{
    let { image , label , mirrorX , size , noIcon , stretch , tabIndex , border =false , link ="#"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        border: border,
        href: link,
        mirrorX: mirrorX !== null && mirrorX !== void 0 ? mirrorX : false,
        noIcon: noIcon !== null && noIcon !== void 0 ? noIcon : false,
        size: size !== null && size !== void 0 ? size : "large",
        stretch: stretch !== null && stretch !== void 0 ? stretch : false,
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                alt: label,
                custom: true,
                jpeg: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionBar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* EyebrowLarge */.Gp, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        uppercase: true,
                        children: label
                    }),
                    Boolean(noIcon) === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LongArrowSideIcons, {
                        size: 24
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/index.ts



/***/ }),

/***/ 15702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ BookingSection; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-booking-section-virtual-2837f2c92b/1/packages/component-booking-section/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  iframe {\n    overflow: hidden;\n    height: 100%;\n    border: none;\n    outline: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a936e0fd-0"
})(_templateObject());
const BookingContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a936e0fd-1"
})(_templateObject1());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-booking-section-virtual-2837f2c92b/1/packages/component-booking-section/src/widget.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-len */ /*
  this is a modified version of the simplybookme widget supplied from the vendor,

  the reason for the modification is the fact that the old script was using document.write
  to append the widget to the page, for information on why this is a bad idea consult this:
  https://developer.mozilla.org/en-US/docs/Web/API/Document/write

  This version appends the widget using innerHTML for a div with an id matching the
  containerID option supplied.

  - Andri Rafn
*/ // @ts-nocheck
class SimplybookWidget {
    init() {
        document.cookie = "sb_widget=1";
        if (!this.options.postpone) {
            switch(this.options.widgetType){
                case "iframe":
                    this.displayIframe();
                    break;
                case "reviews":
                    this.options.navigate = "reviews";
                    this.displayIframe();
                    break;
                case "button":
                    this.addButton();
                    break;
                case "contact-button":
                    this.addContactButton();
                    break;
                case "gift-card":
                    this.options.navigate = "gift-card";
                    this.displayIframe();
                    break;
                case "packages":
                    this.options.navigate = "packages";
                    this.displayIframe();
                    break;
                case "membership":
                    this.options.navigate = "membership";
                    this.displayIframe();
                    break;
            }
        }
    }
    onReceiveMessage(message) {
        if (typeof message.data === "object") {
            if (!this.frame || message.source !== this.frame.contentWindow) {
                return;
            }
            switch(message.data.event){
                case "appReady":
                    this.setSettings(message.data);
                    break;
                case "updateWidgetSize":
                    this.updateWidgetSize(message.data);
                    break;
                case "closeWidget":
                    this.closePopup();
                    break;
                case "modalShown":
                    if (this.options.widgetType === "iframe" || this.options.widgetType === "gift-card" || this.options.widgetType === "packages" || this.options.widgetType === "membership") {
                        this.changeModalPosition(message.data.listener_id);
                    }
                    break;
                case "modalShow":
                    if (this.options.widgetType === "iframe" || this.options.widgetType === "gift-card" || this.options.widgetType === "packages" || this.options.widgetType === "membership") {
                        this.saveModalPosition(message.data.listener_id);
                    }
                    break;
                case "modalHidden":
                    if (this.options.widgetType === "iframe" || this.options.widgetType === "gift-card" || this.options.widgetType === "packages" || this.options.widgetType === "membership") {
                        this.updatePositionAfterModal(message.data.listener_id);
                    }
                    break;
                case "stepChanged":
                case "scrollTo":
                    if (this.options.widgetType === "iframe" || this.options.widgetType === "gift-card" || this.options.widgetType === "packages" || this.options.widgetType === "membership") {
                        this.scrollToContent(message.data.content_position);
                    }
                    break;
            }
        }
    }
    setSettings() {
        const win = this.frame.contentWindow || this.frame;
        const postData = {
            update_config: true,
            update_theme_vars: true,
            rerender: this.options.navigate === null,
            theme_vars: this.options.themeSettings,
            config_vars: this.options.app_config,
            hostname: window.location.hostname
        };
        if (this.options.navigate) {
            postData["navigate"] = this.options.navigate;
            this.options.navigate = null;
        }
        if (this.options.reviews_count || this.options.hide_add_reviews) {
            postData["reviews_vars"] = {
                reviews_count: this.options.reviews_count,
                hide_add_reviews: parseInt(this.options.hide_add_reviews, 10)
            };
        }
        win.postMessage(postData, "*");
    }
    navigate(to) {
        const win = this.frame.contentWindow || this.frame;
        win.postMessage({
            navigate: to
        }, "*");
    }
    scrollToContent(contentPos) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const iframePosition = this.frame.getBoundingClientRect();
        const top = scrollTop + iframePosition.top + contentPos;
        if (scrollTop > top) {
            window.scrollTo(0, top);
        }
    }
    changeModalPosition(listenerId) {
        if (this.modalsPositions[listenerId]) {
            window.scrollTo(0, this.modalsPositions[listenerId]);
        }
        const win = this.frame.contentWindow || this.frame;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const iframePosition = this.frame.getBoundingClientRect();
        const top = scrollTop + iframePosition.top;
        const scrollTo = scrollTop - top;
        win.postMessage({
            update_modal_position: true,
            listener_id: listenerId,
            top: Math.max(scrollTo, 0)
        }, "*");
    }
    saveModalPosition(listenerId) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.modalsPositions[listenerId] = scrollTop;
    }
    updatePositionAfterModal(listenerId) {
        if (this.modalsPositions[listenerId]) {
            window.scrollTo(0, this.modalsPositions[listenerId]);
        }
    }
    getUrl() {
        let widgetType = this.options.widgetType;
        if (widgetType == "contact-button") {
            widgetType = "button";
        }
        const getCookie = (name)=>{
            const value = "; ".concat(document.cookie);
            const parts = value.split("; ".concat(name, "="));
            if (parts.length === 2) return parts.pop().split(";").shift();
        };
        let url = "".concat(this.options.url, "/v2/?widget-type=").concat(widgetType, "&theme=").concat(this.options.theme);
        if (this.options.theme) {
            url += "&theme=".concat(this.options.theme);
        }
        if (this.options.theme_id) {
            url += "&theme_id=".concat(this.options.theme_id);
        }
        if (this.options.timeline) {
            url += "&timeline=".concat(this.options.timeline);
        }
        if (this.options.datepicker) {
            url += "&datepicker=".concat(this.options.datepicker);
        }
        if (this.options.is_rtl) {
            url += "&is_rtl=1";
        }
        if (getCookie("_ga")) {
            url += "&_ga=".concat(getCookie("_ga"));
        }
        return url;
    }
    subscribeMessages() {
        window.addEventListener("message", (data)=>{
            this.onReceiveMessage(data);
        }, false);
    }
    // iframe widget methods
    updateWidgetSize(data) {
        if (this.options.widgetType !== "iframe" && this.options.widgetType !== "gift-card" && this.options.widgetType !== "packages" && this.options.widgetType !== "membership" && this.options.widgetType !== "reviews") {
            return;
        }
        // if(['iframe', 'reviews', 'gift-card', 'package'].indexOf(this.options.widgetType) >= 0){
        //     return;
        // }
        this.frame.height = "".concat(data.height, "px");
        const element = document.getElementById(this.options.containerID);
        if (element) {
            element.style.height = "".concat(data.height, "px");
        }
    }
    displayIframe() {
        const element = document.getElementById(this.options.containerID);
        if (element) {
            const iframe = document.createElement("iframe");
            iframe.class = "sb-widget-iframe";
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.scrolling = "no";
            iframe.border = "0";
            iframe.frameborder = "0";
            iframe.src = this.getUrl();
            iframe.name = this.name;
            iframe.id = this.name;
            element.appendChild(iframe);
        }
        this.frame = document.getElementById(this.name);
        this.subscribeMessages();
    }
    // button widget methods
    addButton() {
        this.addButtonWidgetStyles();
        let btn;
        if (this.options.button_custom_id) {
            btn = document.getElementById(this.options.button_custom_id);
        } else {
            btn = this.getButtonNode();
        }
        btn.addEventListener("click", ()=>{
            this.showPopupFrame("book");
        });
        if (!this.options.button_custom_id) {
            if (!document.body) {
                document.getElementsByTagName("html")[0].appendChild(document.createElement("body"));
            }
            document.body.appendChild(btn);
        }
    }
    addContactButton() {
        this.addButtonWidgetStyles();
        let btn;
        if (this.options.button_custom_id) {
            btn = document.getElementById(this.options.button_custom_id);
        } else {
            btn = this.getButtonNode();
        }
        btn.addEventListener("click", ()=>{
            this.showPopupFrame("contact-widget");
        });
        if (!this.options.button_custom_id) {
            if (!document.body) {
                document.getElementsByTagName("html")[0].appendChild(document.createElement("body"));
            }
            document.body.appendChild(btn);
        }
    }
    getButtonNode() {
        this.btn = document.createElement("div");
        this.btnLabel = document.createElement("div");
        this.btnLabel.innerText = this.options.button_title;
        this.btn.appendChild(this.btnLabel);
        this.updateButtonStyles();
        return this.btn;
    }
    updateButtonStyles(options) {
        if (!this.btn) {
            return;
        }
        if (options) {
            this.options.button_position = options.button_position;
            this.options.button_background_color = options.button_background_color;
            this.options.button_text_color = options.button_text_color;
            this.options.button_position_offset = options.button_position_offset;
            this.options.button_title = options.button_title;
        }
        this.btn.className = "simplybook-widget-button ".concat(this.options.button_position);
        this.btn.style.backgroundColor = this.options.button_background_color;
        this.btn.style.color = this.options.button_text_color;
        if (this.options.button_position === "top" || this.options.button_position === "bottom") {
            this.btn.style.right = this.options.button_position_offset;
            this.btn.style.bottom = "";
        } else {
            this.btn.style.bottom = this.options.button_position_offset;
            this.btn.style.right = "";
        }
        this.btnLabel.innerText = this.options.button_title;
    }
    resetWidget(options) {
        this.options = options;
        this.updateButtonStyles(options);
        this.container = null;
        this.frame = null;
    }
    showPopupFrame(navigateTo) {
        if (navigateTo === undefined) {
            navigateTo = "book";
        }
        if (!this.container) {
            this.container = document.createElement("div");
            this.container.className = "simplybook-widget-container active";
            this.options.navigate = navigateTo;
            this.container.appendChild(this.getIframeNode());
            document.body.appendChild(this.container);
        } else {
            this.container.className = "simplybook-widget-container active";
            this.navigate(navigateTo);
        }
        this.showOverlay();
    }
    closePopup() {
        this.hideOverlay();
        this.container.className = "simplybook-widget-container";
    }
    showOverlay() {
        if (!this.overlay) {
            this.overlay = document.createElement("div");
            this.overlay.className = "simplybook-widget-overlay";
            this.overlay.addEventListener("click", ()=>{
                this.closePopup();
            });
        }
        document.body.appendChild(this.overlay);
        // to show animated appear
        setTimeout(()=>{
            this.overlay.className = "".concat(this.overlay.className, " active");
        }, 10);
    }
    hideOverlay() {
        if (this.overlay) {
            this.overlay.className = "simplybook-widget-overlay";
            setTimeout(()=>{
                document.body.removeChild(this.overlay);
            }, 300);
        }
    }
    addButtonWidgetStyles() {
        const link = document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", "".concat(this.options.url, "/v2/widget/widget.css"));
        document.getElementsByTagName("head")[0].appendChild(link);
    }
    getIframeNode() {
        if (!this.frame) {
            this.frame = document.createElement("iframe");
            this.frame.border = "0";
            this.frame.frameBorder = "0";
            if (this.options.widgetType == "iframe") {
                this.frame.scrolling = "no";
            }
            this.frame.name = this.name;
            this.frame.id = this.name;
            this.frame.src = this.getUrl();
            this.subscribeMessages();
        }
        return this.frame;
    }
    constructor(options){
        this.options = {
            // common options
            widgetType: "iframe",
            theme: "default",
            containerID: "simplybookme-widget-container",
            themeSettings: {},
            app_config: {},
            timeline: null,
            datepicker: null,
            url: "",
            // iframe widget options
            iframe_postpone: false,
            // button widget options
            button_position: "right",
            button_position_offset: "auto",
            button_background_color: "#06acee",
            button_text_color: "#ffffff",
            button_title: "Book Now",
            button_preload: true,
            button_custom_id: null,
            navigate: "book"
        };
        this.modalsPositions = {};
        this.name = "widget_".concat(Math.random());
        this.frame = null;
        for(const name in options){
            if (!options.hasOwnProperty(name)) {
                continue;
            }
            this.options[name] = options[name];
        }
        this.init();
    }
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-booking-section-virtual-2837f2c92b/1/packages/component-booking-section/src/booking-section.tsx





const BookingSection = ()=>{
    const [injectedBookingScript, setInjectedBookingScript] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!injectedBookingScript && document.getElementById("simply-book-widget-script") === null) {
            new SimplybookWidget({
                widgetType: "iframe",
                url: "https://byko.simplybook.it",
                theme: "emeri",
                containerID: "booking-widget-container",
                themeSettings: {
                    timeline_hide_unavailable: "1",
                    sb_base_color: src/* theme.palette.blue.main */.rS.palette.blue.main,
                    hide_past_days: "0",
                    timeline_show_end_time: "0",
                    timeline_modern_display: "as_slots",
                    display_item_mode: "block",
                    sb_review_image: "",
                    dark_font_color: src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    light_font_color: src/* theme.palette.white.main */.rS.palette.white.main,
                    background_color: "red",
                    sb_company_label_color: src/* theme.palette.white.main */.rS.palette.white.main,
                    hide_img_mode: "0",
                    show_sidebar: "1",
                    sb_busy: src/* theme.palette.gray.40 */.rS.palette.gray[40],
                    sb_available: "#d3e0f1"
                },
                timeline: "modern_week",
                datepicker: "top_calendar",
                is_rtl: false,
                app_config: {
                    allow_switch_to_ada: 0,
                    predefined: []
                }
            });
            setInjectedBookingScript(true);
        }
    }, [
        injectedBookingScript
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingContainer, {
            id: "booking-widget-container"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-booking-section-virtual-2837f2c92b/1/packages/component-booking-section/src/index.ts



/***/ }),

/***/ 55313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ ContentSectionImageTiles; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-image-tile-virtual-f51c810f9c/1/packages/component-image-tile/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  padding: ",
        ";\n  background-color: ",
        ";\n  transition: 300ms;\n\n  @media screen and (max-width: ",
        "px) {\n    width: ",
        ";\n    height: ",
        ";\n    padding: ",
        ";\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    width: 265px;\n    height: 265px;\n    padding: 12px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ef95b838-0"
})(_templateObject(), (props)=>props.size === "large" ? "452px" : props.size === "medium" ? "336px" : "265px", (props)=>props.size === "large" ? "452px" : props.size === "medium" ? "336px" : "265px", (props)=>props.size === "large" ? "20px" : props.size === "medium" ? "16px" : "12px", src/* theme.palette.white.main */.rS.palette.white.main, src/* gridTheme.breakpoints.s */.k.breakpoints.s, (props)=>props.size === "small" ? "253px" : "336px", (props)=>props.size === "small" ? "253px" : "336px", (props)=>props.size === "small" ? "12px" : "16px", src/* gridTheme.breakpoints.xs */.k.breakpoints.xs);
const Image = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-ef95b838-1"
})(_templateObject1());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-image-tile-virtual-f51c810f9c/1/packages/component-image-tile/src/image-tile.tsx



const ImageTile = (param)=>{
    let { image , alt , size ="large"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
            alt: alt,
            src: image
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-image-tile-virtual-f51c810f9c/1/packages/component-image-tile/src/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-image-tiles-virtual-f05c5d4c6c/1/packages/component-content-section-image-tiles/src/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  max-width: ",
        "px;\n  flex-wrap: wrap;\n  justify-content: ",
        ";\n  margin-right: auto;\n  margin-left: auto;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}


const styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4aa0003c-0"
})(styles_templateObject(), src/* gridTheme.maxContentWidth */.k.maxContentWidth, (props)=>props.variant === "left-aligned" ? "flex-start" : "flex-end", (props)=>props.variant === "left-aligned" ? "16px" : props.size === "large" ? "85px" : props.size === "medium" ? "74px" : "56px", (props)=>props.variant === "right-aligned" ? "16px" : props.size === "large" ? "85px" : props.size === "medium" ? "74px" : "56px");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-image-tiles-virtual-f05c5d4c6c/1/packages/component-content-section-image-tiles/src/component-content-section-image-tiles.tsx




const ContentSectionImageTiles = (param)=>{
    let { tiles , variant , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        variant: variant,
        children: tiles.map((param)=>{
            let { alt , image , id  } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTile, {
                alt: alt,
                image: image,
                size: size
            }, id);
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-image-tiles-virtual-f05c5d4c6c/1/packages/component-content-section-image-tiles/src/index.ts



/***/ }),

/***/ 26057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ContentSectionPhotoAlbum; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/swiper-react.js + 105 modules
var swiper_react = __webpack_require__(13682);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var component_page_container_src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/index.ts + 21 modules
var component_slider_src = __webpack_require__(54573);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(14150);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/components/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 120px;\n  justify-content: space-between;\n  gap: 8px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3000001;\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: center;\n  justify-content: center;\n  padding-right: 140px;\n  padding-left: 140px;\n  margin-top: 42px;\n  margin-bottom: 32px;\n  gap: 16px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 4px;\n  background-color: ",
        ";\n  outline: 1px solid ",
        ";\n  &:after {\n    position: absolute;\n    width: ",
        ";\n    height: 100%;\n    background-color: ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n'
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const ActionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c2eda975-0"
})(_templateObject());
const ProgressContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c2eda975-1"
})(_templateObject1());
const ProgressBar = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c2eda975-2"
})(_templateObject2(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.status, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/components/progress-handler.tsx







const ProgressHandler = (param)=>{
    let { progress  } = param;
    const leftPress = (0,lib_utils_src/* useKeyPress */.Kr)("ArrowLeft");
    const rightPress = (0,lib_utils_src/* useKeyPress */.Kr)("ArrowRight");
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    const handleNext = (0,react.useCallback)(()=>{
        swiper.slideNext();
    }, [
        swiper
    ]);
    const handlePrevious = (0,react.useCallback)(()=>{
        swiper.slidePrev();
    }, [
        swiper
    ]);
    (0,react.useEffect)(()=>{
        if (leftPress) {
            handlePrevious();
        }
        if (rightPress) {
            handleNext();
        }
    }, [
        handleNext,
        handlePrevious,
        leftPress,
        rightPress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProgressContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                status: progress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                        ariaLabel: "Seinasta Mynd",
                        icon: lib_icons_src.ArrowLeftIcons,
                        onClick: handlePrevious
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                        ariaLabel: "N\xe6sta Mynd",
                        icon: lib_icons_src.ArrowRightIcons,
                        onClick: handleNext
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/components/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 3000000;\n  top: 0;\n  right: 48px;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3000000;\n  width: 100%;\n  height: 100%;\n  .swiper {\n    overflow: unset;\n    height: calc(100% - 100px) !important;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: auto;\n  max-width: 90%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 2000000;\n  display: block;\n  inset: 0;\n  opacity: 0;\n  &.fade-in {\n    opacity: 0.4;\n    transition: 300ms;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 3000000;\n  display: flex;\n  flex-direction: column;\n  padding-top: 32px;\n  padding-bottom: 32px;\n\n  background-color: rgba(255, 255, 255, 0.9);\n  inset: 122px 32px 32px 32px;\n  opacity: 0;\n  outline: 2px solid white;\n  transition: 300ms;\n\n  &.fade-in {\n    opacity: 1;\n    transition: 300ms;\n  }\n\n  @media screen and (max-width: 1438px) {\n    inset: 86px 0px 0px 0px;\n  }\n  @media screen and (max-width: 768px) {\n    padding-right: 16px;\n    padding-left: 16px;\n    background-color: rgba(255, 255, 255, 1);\n    inset: 0px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-top: 48px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  object-fit: cover;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 132px;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  .swiper-slide {\n    width: 300px !important;\n    height: 200px !important;\n    img {\n      width: 100% !important;\n      height: 200px !important;\n      object-fit: cover;\n    }\n  }\n  @media screen and (max-width: 375px) {\n    .swiper-slide {\n      width: calc(100% - 48px) !important;\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 180px;\n  justify-content: space-between;\n  transition: 300ms;\n  svg {\n    transition: 300ms;\n  }\n  p {\n    font-weight: 400;\n  }\n  &:after {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 24px;\n    height: 1px;\n    background-color: ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n  &:hover {\n    svg {\n      transform: translateX(8px);\n    }\n    &:after {\n      width: 48px;\n    }\n  }\n'
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}


const CloseButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-0"
})(styles_templateObject());
const SwiperContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-1"
})(styles_templateObject1());
const SliderImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-44794880-2"
})(styles_templateObject2());
const OverlayOuter = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-44794880-3"
})(_templateObject3());
const OverlayContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-4"
})(_templateObject4());
const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-5"
})(_templateObject5(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const AlbumItemContainerBig = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-6"
})(_templateObject6());
const ImageBlock = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-44794880-7"
})(_templateObject7());
const ResultsRowSwiper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-8"
})(_templateObject8());
const GallerySliderWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-9"
})(_templateObject9());
const AlbumItemContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-10"
})(_templateObject10());
const HeaderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-44794880-11"
})(_templateObject11());
const ViewAlbumButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-44794880-12"
})(_templateObject12(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/componen-content-section-photo-album.tsx













const ContentSectionPhotoAlbum = (param)=>{
    let { photos  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const escapePress = (0,lib_utils_src/* useKeyPress */.Kr)("Escape");
    const [overlayActive, setOverlayActive] = (0,react.useState)(false);
    const [fadeInClass, setFadeInClass] = (0,react.useState)("");
    const [progress, setProgress] = (0,react.useState)("0%");
    const imageSlides = (0,react.useMemo)(()=>{
        const images = photos.map((item)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumItemContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {
                    alt: item.alt,
                    src: item.jpeg
                })
            }, item.jpeg);
        });
        return images;
    }, [
        photos
    ]);
    const selectImage = (0,react.useCallback)(()=>{
        setOverlayActive(true);
    }, []);
    const closePhotoAlbum = (0,react.useCallback)(()=>{
        setOverlayActive(false);
    }, []);
    (0,react.useEffect)(()=>{
        if (escapePress) {
            closePhotoAlbum();
        }
    }, [
        closePhotoAlbum,
        escapePress
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            const element = document.querySelector("body");
            if (overlayActive) {
                element === null || element === void 0 ? void 0 : element.classList.add("no-scroll");
            } else {
                element === null || element === void 0 ? void 0 : element.classList.remove("no-scroll");
            }
        }
        setTimeout(()=>{
            setFadeInClass(overlayActive ? "fade-in" : "");
        }, 100);
    }, [
        overlayActive
    ]);
    const handleChange = (0,react.useCallback)((swiper)=>{
        const slidesPerView = 1;
        const localProgress = (slidesPerView + swiper.activeIndex) / photos.length * 100;
        setProgress(localProgress <= 100 ? "".concat(localProgress, "%") : "100%");
    }, [
        photos.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsRowSwiper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_page_container_src/* PageContainer */._, {
                        flexDirection: "column",
                        offsetNav: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewAlbumButton, {
                                onClick: selectImage,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                                        iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                                        children: "Sko\xf0a myndaalb\xfam"
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GallerySliderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_slider_src/* Slider */.iR, {
                    autoPad: true,
                    paginationGutter: true,
                    slideCollection: imageSlides,
                    onClick: selectImage
                })
            }),
            overlayActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayOuter, {
                        className: fadeInClass,
                        onClick: closePhotoAlbum
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayContainer, {
                        active: overlayActive,
                        className: fadeInClass,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                onAfterInit: handleChange,
                                onResize: handleChange,
                                onTransitionStart: handleChange,
                                children: [
                                    photos.map((slideContent)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumItemContainerBig, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImage, {
                                                    src: slideContent.jpeg
                                                })
                                            })
                                        }, slideContent.jpeg);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressHandler, {
                                        progress: progress
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                                            ariaLabel: "Loka",
                                            buttonColor: "blueButton",
                                            icon: lib_icons_src.CancelSmallIcons,
                                            small: [
                                                "xs",
                                                "s",
                                                "sm"
                                            ].includes(activeBreakPoint),
                                            onClick: closePhotoAlbum
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/index.ts



/***/ }),

/***/ 24844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ ContentSectionEight; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-eight-virtual-ecb8360025/1/packages/component-content-section-variant-eight/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  padding-top: 48px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  width: fit-content;\n  align-items: center;\n  grid-column-gap: ",
        ";\n  grid-template-areas: ",
        ";\n  grid-template-columns: ",
        ";\n\n  @media screen and (max-width: ",
        'px) {\n    grid-gap: 10px;\n    grid-template-areas:\n      "images"\n      "textblock";\n    grid-template-columns: 1fr;\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding-top: 24px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  left: 124px;\n  display: flex;\n  width: calc(100% - 124px);\n  height: 100%;\n  flex-direction: column;\n  row-gap: 16px;\n  @media screen and (max-width: ",
        "px) {\n    left: 0;\n    width: 100%;\n    height: 330px;\n    margin-top: 48px;\n  }\n  img {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    @media screen and (max-width: ",
        "px) {\n      height: 480px;\n    }\n    @media screen and (max-width: ",
        "px) {\n      height: 250px;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  grid-area: images;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  row-gap: 56px;\n  transform: translate3d(0, -48px, 0);\n\n  @media screen and (max-width: ",
        "px) {\n    top: 0;\n    left: 16px;\n    width: 100%;\n    height: unset;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: flex-start;\n    padding-right: 8px;\n    gap: 8px;\n    transform: translate3d(0, 0, 0);\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  width: 320px;\n  height: 320px;\n  min-height: 320px;\n  filter: drop-shadow(0px 14px 48px rgba(0, 0, 0, 0.16));\n  @media screen and (max-width: ",
        "px) {\n    width: 280px;\n    height: 280px;\n    min-height: 280px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 200px;\n    height: 200px;\n    min-height: 200px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 110px;\n    height: 110px;\n    min-height: 110px;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const Block = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-1"
})(_templateObject1(), (props)=>props.mirrorX ? "129px " : "129px", (props)=>props.mirrorX ? '"images textblock"' : '"textblock images"', (props)=>props.mirrorX ? "6fr 4fr" : "4fr 6fr", lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const TextBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-2"
})(_templateObject2());
const DecorativeImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-3"
})(_templateObject3(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm, lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs);
const ImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-4"
})(_templateObject4());
const Images = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-5"
})(_templateObject5());
const SmallImageOverlay = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-6"
})(_templateObject6(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const SmallImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5021ee77-7"
})(_templateObject7(), lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-eight-virtual-ecb8360025/1/packages/component-content-section-variant-eight/src/content-section-variant-eight.tsx





const ContentSectionEight = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , mirrorX =false , introText , decorativeImageOne , smallImageOne , smallImageTwo , actionButton  } = param;
    const hasSmallImage = (0,react.useMemo)(()=>{
        return smallImageOne !== undefined || smallImageTwo !== undefined;
    }, [
        smallImageOne,
        smallImageTwo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
            mirrorX: mirrorX,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockContainer, {
                    hasSmallImage: hasSmallImage,
                    mirrorX: mirrorX,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        paragraph: paragraph
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Images, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                            mirrorX: mirrorX,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageContainer, {
                                mirrorX: mirrorX,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                    ...decorativeImageOne
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImageOverlay, {
                            mirrorX: mirrorX,
                            children: [
                                smallImageOne && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...smallImageOne
                                    })
                                }),
                                smallImageTwo && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...smallImageTwo
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-eight-virtual-ecb8360025/1/packages/component-content-section-variant-eight/src/index.ts



/***/ }),

/***/ 63925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ ContentSectionNine; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/index.ts + 2 modules
var src = __webpack_require__(30536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-nine-virtual-3e34b29b90/1/packages/component-content-section-variant-nine/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  align-items: center;\n  grid-column-gap: ",
        ";\n  grid-template-areas: ",
        ";\n  grid-template-columns: ",
        ";\n\n  @media screen and (max-width: ",
        'px) {\n    grid-gap: 10px;\n    grid-template-areas:\n      "textblock"\n      "cards";\n    grid-template-columns: 1fr;\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: textblock;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1000px;\n  flex-flow: wrap;\n  margin-top: 16px;\n  margin-bottom: 2rem;\n  gap: 16px;\n  grid-area: cards;\n\n  @media screen and (min-width: ",
        "px) {\n    .block-image-link {\n      :hover {\n        filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.09));\n      }\n    }\n  }\n  @media screen and (max-width: 1079px) {\n    margin-top: 0px;\n  }\n  @media screen and (max-width: 469px) {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b5bae2c5-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const Block = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b5bae2c5-1"
})(_templateObject1(), (props)=>props.mirrorX ? "5px " : "129px", (props)=>props.mirrorX ? '"textblock textblock"\n    "cards cards"' : '"textblock textblock"\n    "cards cards"', (props)=>props.mirrorX ? "6fr 4fr" : "4fr 6fr", lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const TextBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b5bae2c5-2"
})(_templateObject2());
const TextBlock = (0,styled_components_browser_cjs["default"])(component_text_block_variant_one_src/* TextBlockVariantOne */.p).withConfig({
    componentId: "sc-b5bae2c5-3"
})(_templateObject3());
const CardsImageLinkWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b5bae2c5-4"
})(_templateObject4(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-nine-virtual-3e34b29b90/1/packages/component-content-section-variant-nine/src/content-section-variant-nine.tsx




const ContentSectionNine = (param)=>{
    let { heading , paragraph , cards , headingUnderlineColor ="blueLine" , headingDecoration , mirrorX =false , introText , actionButton  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
            mirrorX: mirrorX,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockContainer, {
                    mirrorX: mirrorX,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        paragraph: paragraph
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsImageLinkWrapper, {
                    children: cards.map((card)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                            border: true,
                            image: card.image,
                            label: card.label,
                            link: card.link,
                            mirrorX: true,
                            size: "large"
                        }, card.label))
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-nine-virtual-3e34b29b90/1/packages/component-content-section-variant-nine/src/index.ts



/***/ }),

/***/ 44674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jt": function() { return /* reexport */ DatoImage; }
});

// UNUSED EXPORTS: ImageSource, ImageSources, imageURL

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/cache/blurhash-npm-1.1.5-720540d109-8a64702494.zip/node_modules/blurhash/dist/esm/decode.js + 3 modules
var decode = __webpack_require__(61335);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-util-blurhash-virtual-59c6e03f37/1/packages/util-blurhash/src/generate-png.ts
/* eslint-disable @typescript-eslint/no-shadow */ const generatePng = (width, height, rgbaString)=>{
    const DEFLATE_METHOD = String.fromCharCode(0x78, 0x01);
    const CRC_TABLE = [];
    const SIGNATURE = String.fromCharCode(137, 80, 78, 71, 13, 10, 26, 10);
    const NO_FILTER = String.fromCharCode(0);
    let n, c, k;
    // make crc table
    for(n = 0; n < 256; n++){
        c = n;
        for(k = 0; k < 8; k++){
            if (c & 1) {
                c = 0xedb88320 ^ c >>> 1;
            } else {
                c = c >>> 1;
            }
        }
        CRC_TABLE[n] = c;
    }
    // Functions
    function inflateStore(data) {
        const MAX_STORE_LENGTH = 65535;
        let storeBuffer = "";
        let remaining;
        let blockType;
        for(let i = 0; i < data.length; i += MAX_STORE_LENGTH){
            remaining = data.length - i;
            blockType = "";
            if (remaining <= MAX_STORE_LENGTH) {
                blockType = String.fromCharCode(0x01);
            } else {
                remaining = MAX_STORE_LENGTH;
                blockType = String.fromCharCode(0x00);
            }
            // little-endian
            storeBuffer += blockType + String.fromCharCode(remaining & 0xff, (remaining & 0xff00) >>> 8);
            storeBuffer += String.fromCharCode(~remaining & 0xff, (~remaining & 0xff00) >>> 8);
            storeBuffer += data.substring(i, i + remaining);
        }
        return storeBuffer;
    }
    function adler32(data) {
        const MOD_ADLER = 65521;
        let a = 1;
        let b = 0;
        for(let i = 0; i < data.length; i++){
            a = (a + data.charCodeAt(i)) % MOD_ADLER;
            b = (b + a) % MOD_ADLER;
        }
        return b << 16 | a;
    }
    function updateCrc(crc, buf) {
        let c = crc;
        let b;
        for(let n = 0; n < buf.length; n++){
            b = buf.charCodeAt(n);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            c = CRC_TABLE[(c ^ b) & 0xff] ^ c >>> 8;
        }
        return c;
    }
    function crc(buf) {
        return updateCrc(0xffffffff, buf) ^ 0xffffffff;
    }
    function dwordAsString(dword) {
        return String.fromCharCode((dword & 0xff000000) >>> 24, (dword & 0x00ff0000) >>> 16, (dword & 0x0000ff00) >>> 8, dword & 0x000000ff);
    }
    function createChunk(length, type, data) {
        const CRC = crc(type + data);
        return dwordAsString(length) + type + data + dwordAsString(CRC);
    }
    function createIHDR(width, height) {
        const IHDRdata = dwordAsString(width) + dwordAsString(height) + // bit depth
        String.fromCharCode(8) + // color type: 6=truecolor with alpha
        String.fromCharCode(6) + // compression method: 0=deflate, only allowed value
        String.fromCharCode(0) + // filtering: 0=adaptive, only allowed value
        String.fromCharCode(0) + // interlacing: 0=none
        String.fromCharCode(0);
        return createChunk(13, "IHDR", IHDRdata);
    }
    // PNG creations
    const IEND = createChunk(0, "IEND", "");
    const IHDR = createIHDR(width, height);
    let scanlines = "";
    let scanline;
    for(let y = 0; y < rgbaString.length; y += width * 4){
        scanline = NO_FILTER;
        if (Array.isArray(rgbaString)) {
            for(let x = 0; x < width * 4; x++){
                scanline += String.fromCharCode(rgbaString[y + x] & 0xff);
            }
        } else {
            scanline += rgbaString.substr(y, width * 4);
        }
        scanlines += scanline;
    }
    const compressedScanlines = DEFLATE_METHOD + inflateStore(scanlines) + dwordAsString(adler32(scanlines));
    const IDAT = createChunk(compressedScanlines.length, "IDAT", compressedScanlines);
    const pngString = SIGNATURE + IHDR + IDAT + IEND;
    return pngString;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-util-blurhash-virtual-59c6e03f37/1/packages/util-blurhash/src/get-png-array.ts
const getPngArray = (pngString)=>{
    const pngArray = new Uint8Array(pngString.length);
    for(let i = 0; i < pngString.length; i++){
        pngArray[i] = pngString.charCodeAt(i);
    }
    return pngArray;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-util-blurhash-virtual-59c6e03f37/1/packages/util-blurhash/src/parse-pixels.ts
/* provided dependency */ var Buffer = __webpack_require__(85474)["Buffer"];


const parsePixels = (pixels, width, height)=>{
    const pixelsString = [
        ...pixels
    ].map((byte)=>String.fromCharCode(byte)).join("");
    const pngString = generatePng(width, height, pixelsString);
    const dataURL = typeof Buffer !== "undefined" ? Buffer.from(getPngArray(pngString)).toString("base64") : btoa(pngString);
    return "data:image/png;base64,".concat(dataURL);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-util-blurhash-virtual-59c6e03f37/1/packages/util-blurhash/src/blur-hash-data-to-url.ts


const blurHashToDataURL = (hash)=>{
    if (!hash) return undefined;
    const pixels = (0,decode/* default */.Z)(hash, 32, 32);
    const dataURL = parsePixels(pixels, 32, 32);
    return dataURL;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-util-blurhash-virtual-59c6e03f37/1/packages/util-blurhash/src/index.ts
// Based on this https://gist.github.com/mattiaz9/53cb67040fa135cb395b1d015a200aff


// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/style.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: block;\n  overflow: hidden;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  box-sizing: border-box;\n  padding: 0;\n  border: 0;\n  margin: auto;\n  inset: 0px;\n  object-fit: cover !important;\n  text-indent: -200%;\n  white-space: nowrap;\n  &:-moz-loading {\n    visibility: hidden;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  overflow: hidden;\n  width: initial;\n  height: initial;\n  box-sizing: border-box;\n  padding: 0;\n  border: 0;\n  margin: 0;\n  background: none;\n  opacity: 1;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const HIDE_CLASSNAME = "hide";
const SHOW_CLASSNAME = "show";
const DatoImg = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-2a8eb30e-0"
})(_templateObject());
const DatoInnerContainer = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-2a8eb30e-1"
})(_templateObject1());
const DatoImageComponent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a8eb30e-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/component-dato-image.tsx





const EMPTYIMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const SIZES = [
    640,
    750,
    828,
    1080,
    1200,
    1920,
    2048,
    3840
];
const SMALLESTIMAGE = SIZES[0];
const imageURL = (param)=>{
    let { url , width , webp =false  } = param;
    if (!url) {
        return EMPTYIMAGE;
    }
    const host = (0,src/* getBykoConfig */.Hp)("IMAGES_API_URL");
    if (webp) {
        return "".concat(host, "/?width=").concat(width, "&format=webp&url=").concat(url);
    }
    return "".concat(host, "/?width=").concat(width, "&url=").concat(url);
};
const ImageSource = (param)=>{
    let { url , width , minWidth  } = param;
    if (minWidth == null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(width - 1, "px)"),
                    srcSet: imageURL({
                        url,
                        width,
                        webp: true
                    })
                }, "".concat(width, ".webp")),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(width - 1, "px)"),
                    srcSet: imageURL({
                        url,
                        width
                    })
                }, width)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(min-width: ".concat(minWidth, "px)"),
                srcSet: imageURL({
                    url,
                    width,
                    webp: true
                })
            }, "".concat(width, ".webp")),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(min-width: ".concat(minWidth, "px)"),
                srcSet: imageURL({
                    url,
                    width
                })
            }, width)
        ]
    });
};
const ImageSources = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: SIZES.map((e, i, arr)=>{
            var ref;
            const minWidth = (ref = arr[i - 1]) !== null && ref !== void 0 ? ref : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSource, {
                minWidth: minWidth,
                url: url,
                width: e
            }, e);
        })
    });
};
const DatoImage = (param)=>{
    let { blurHash , alt ="" , jpeg , className , objectPosition , custom , priority =false  } = param;
    const isClient = (0,src/* useIsClient */.O_)();
    const style = (0,react.useMemo)(()=>{
        if (!isClient) {
            if (custom) {
                return {};
            }
            return {
                objectPosition: objectPosition !== null && objectPosition !== void 0 ? objectPosition : "center center",
                backgroundSize: "cover"
            };
        }
        try {
            const url = blurHashToDataURL(blurHash);
            const background = blurHash ? {
                backgroundImage: "url(".concat(url, ")")
            } : {};
            if (custom) {
                return background;
            }
            return {
                objectPosition: objectPosition !== null && objectPosition !== void 0 ? objectPosition : "center center",
                backgroundSize: "cover",
                ...background
            };
        } catch (e) {
            return {
                objectPosition: objectPosition !== null && objectPosition !== void 0 ? objectPosition : "center center"
            };
        }
    }, [
        isClient,
        custom,
        objectPosition,
        blurHash
    ]);
    if (custom) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            className: className,
            children: [
                jpeg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSources, {
                    url: jpeg
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    alt: alt,
                    className: className,
                    loading: priority ? "eager" : "lazy",
                    src: blurHash !== null && blurHash !== void 0 ? blurHash : EMPTYIMAGE,
                    style: style
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatoImageComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatoInnerContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                children: [
                    jpeg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSources, {
                        url: jpeg
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatoImg, {
                        alt: alt,
                        className: className,
                        loading: priority ? "eager" : "lazy",
                        src: imageURL({
                            width: SMALLESTIMAGE,
                            url: jpeg
                        }),
                        style: style
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts



/***/ }),

/***/ 17961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ ContentSectionHtmlBlock; }
});

// UNUSED EXPORTS: IframeContainer

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-html-block-virtual-283fe47e85/1/packages/component-content-section-html-block/src/component-content-html-block.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  iframe {\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    border: none;\n    outline: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const IframeContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-360a6c58-0"
})(_templateObject());
const ContentSectionHtmlBlock = (param)=>{
    let { content  } = param;
    const iframeRef = /*#__PURE__*/ react.createRef();
    const [isIframeLoaded, setIsIframeLoaded] = (0,react.useState)(false);
    const FRAME_PADDING = 30;
    const setFrameHeight = (0,react.useCallback)(()=>{
        if (false) {}
        const element = iframeRef.current;
        if (element && element.contentWindow && element.contentDocument) {
            // Create and add resize observer
            const resizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const height = entry.target.scrollHeight;
                    element.style.height = "".concat(height + FRAME_PADDING, "px");
                }
            });
            // Observe the iframe's document body
            if (element.contentDocument.body) {
                resizeObserver.observe(element.contentDocument.body);
                // Initial height set
                element.style.height = "".concat(element.contentDocument.body.scrollHeight + FRAME_PADDING, "px");
            }
            // Cleanup observer when iframe changes
            return ()=>resizeObserver.disconnect();
        }
        return undefined;
    }, [
        iframeRef
    ]);
    // Handle iframe load event
    const handleIframeLoad = (0,react.useCallback)(()=>{
        setIsIframeLoaded(true);
        // Small delay to ensure content is fully rendered
        setTimeout(()=>{
            setFrameHeight();
        }, 100);
    }, [
        setFrameHeight
    ]);
    (0,react.useEffect)(()=>{
        if (isIframeLoaded) {
            setFrameHeight();
        }
    }, [
        setFrameHeight,
        isIframeLoaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            ref: iframeRef,
            srcDoc: content.html,
            title: "custom",
            onLoad: handleIframeLoad
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-html-block-virtual-283fe47e85/1/packages/component-content-section-html-block/src/index.ts



/***/ }),

/***/ 77075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ ContentSectionVariantFive; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(89976);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-five-virtual-773febb0c4/1/packages/component-content-section-variant-five/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-bottom: -48px;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  align-items: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 0px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 0px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 0px;\n  }\n  @media screen and (max-width: 375px) {\n    padding: 48px 0px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: ",
        ";\n  padding-top: 48px;\n  padding-bottom: 48px;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: 1104px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  align-items: ",
        ";\n  justify-content: center;\n  padding-top: 64px;\n  padding-bottom: 64px;\n  row-gap: 16px;\n  transition: 300ms;\n  @media screen and (max-width: ",
        "px) {\n    padding-right: 32px;\n    padding-left: 32px;\n  }\n  @media screen and (max-width: 375px) {\n    padding-right: 0px;\n    padding-left: 0px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: -1;\n  ",
        ";\n  width: 63%;\n  height: 100%;\n  img {\n    object-fit: cover !important;\n  }\n  @media screen and (max-width: 1389px) {\n    width: 70%;\n  }\n  @media screen and (max-width: 970px) {\n    width: 100%;\n    margin-bottom: -180px;\n  }\n  @media screen and (max-width: 375px) {\n    img {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const BlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-1"
})(_templateObject1());
const Block = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-2"
})(_templateObject2(), lib_styles_src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const TextBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-3"
})(_templateObject3(), (props)=>props.mirrorY ? "flex-end" : "flex-start", lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md);
const ListContentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-4"
})(_templateObject4());
const TextRows = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-5"
})(_templateObject5(), (props)=>props.mirrorY ? "flex-start" : "flex-end", lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md);
const BackdropImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-bcd6b39b-6"
})(_templateObject6(), (props)=>props.mirrorY ? "right: 0px" : "left: 0px");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-five-virtual-773febb0c4/1/packages/component-content-section-variant-five/src/content-section-variant-five.tsx






const TextBlockVariantThree = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4773).then(__webpack_require__.bind(__webpack_require__, 24773)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24773)
            ]
    },
    ssr: false
});
const ContentSectionVariantFive = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , mirrorY =false , introText , decorativeImageOne , textRows , actionButton  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlockContainer, {
                    mirrorY: mirrorY,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                            buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                            buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                            heading: heading,
                            headingDecoration: headingDecoration,
                            headingUnderlineColor: headingUnderlineColor,
                            introText: introText,
                            paragraph: paragraph
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListContentContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackdropImageContainer, {
                                    mirrorY: mirrorY,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...decorativeImageOne
                                    })
                                }),
                                textRows && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextRows, {
                                    mirrorY: mirrorY,
                                    children: textRows.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockVariantThree, {
                                            icon: row.icon,
                                            mirrorY: mirrorY,
                                            number: row.number,
                                            paragraph: row.paragraph,
                                            title: row.title
                                        }, row.id))
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-five-virtual-773febb0c4/1/packages/component-content-section-variant-five/src/index.ts



/***/ }),

/***/ 98986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ ContentSectionVariantFour; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/index.ts + 2 modules
var src = __webpack_require__(30536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var component_dato_image_src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-two-virtual-f35df584f7/1/packages/component-text-block-variant-two/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-top: 16px;\n  padding-left: 36px;\n  &::before {\n    position: absolute;\n    top: 16px;\n    bottom: 0;\n    left: 0;\n    width: 12px;\n    height: 12px;\n    background-color: ",
        ';\n    clip-path: polygon(100% 50%, 0 0, 0 100%);\n    content: "";\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 48px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



const ContentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8810fd48-0"
})(_templateObject());
const ItemSection = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8810fd48-1"
})(_templateObject1());
const SectionTitle = (0,styled_components_browser_cjs["default"])(component_typography_src/* SubtitleBold */.zE).withConfig({
    componentId: "sc-8810fd48-2"
})(_templateObject2());
const SectionContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8810fd48-3"
})(_templateObject3(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const SBBackdrop = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8810fd48-4"
})(_templateObject4(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-two-virtual-f35df584f7/1/packages/component-text-block-variant-two/src/text-block-variant-two.tsx





const TextBlockVariantTwo = (param)=>{
    let { heading , introText , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , itemSection , buttonLabel , buttonLink  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                buttonLabel: buttonLabel,
                buttonLink: buttonLink,
                heading: heading,
                headingDecoration: headingDecoration,
                headingUnderlineColor: headingUnderlineColor,
                introText: introText,
                maxColumns: 1,
                paragraph: paragraph
            }),
            itemSection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        uppercase: true,
                        children: itemSection.title
                    }),
                    itemSection.items.map((param)=>{
                        let { id , content  } = param;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent, {
                            children: content
                        }, id);
                    })
                ]
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-two-virtual-f35df584f7/1/packages/component-text-block-variant-two/src/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-four-virtual-15c0ed80e6/1/packages/component-content-section-variant-four/src/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  align-items: center;\n  grid-gap: 129px;\n  grid-template-areas: ",
        ";\n  grid-template-columns: 1fr 1fr;\n\n  @media screen and (max-width: ",
        "px) {\n    grid-gap: 48px;\n    grid-template-areas: ",
        ";\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  padding-top: 48px;\n  padding-bottom: 48px;\n  @media screen and (max-width: ",
        "px) {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  grid-area: textblock;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  row-gap: 16px;\n  @media screen and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  img {\n    object-fit: cover !important;\n  }\n  @media screen and (max-width: ",
        "px) {\n    height: 480px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  grid-area: images;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: ",
        ";\n  justify-content: center;\n  inset-block: 0;\n  row-gap: 16px;\n  transform: translate3d(",
        ", 0, 0);\n  @media screen and (max-width: ",
        "px) {\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    align-items: center;\n    justify-content: ",
        ";\n    transform: translate3d(-50%, 0, 0);\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 2;\n  overflow: hidden;\n  width: fit-content;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 288px;\n  height: 266px;\n  object-fit: cover;\n  @media screen and (max-width: 970px) {\n    width: min(288px, 100%);\n    height: min(266px, 100%);\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 288px;\n  height: 56px;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  transform: translate3d(0, -6px, 0);\n  @media screen and (max-width: ",
        "px) {\n    width: 217px;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}



const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-0"
})(styles_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const Block = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-1"
})(styles_templateObject1(), (props)=>props.mirrorY ? '"images textblock"' : '"textblock images"', lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md, (props)=>props.mirrorY ? '"images"\n    "textblock"' : '"textblock"\n    "images"');
const TextBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-2"
})(styles_templateObject2(), lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md);
const TextBlock = (0,styled_components_browser_cjs["default"])(TextBlockVariantTwo).withConfig({
    componentId: "sc-edc59667-3"
})(styles_templateObject3());
const DecorativeImageContainerWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-4"
})(styles_templateObject4(), lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md, (props)=>!props.mirrorY && props.tagCount === 2 ? "451px" : !props.mirrorY && props.tagCount === 1 ? "160px" : "0px", (props)=>props.mirrorY && props.tagCount === 2 ? "451px" : props.mirrorY && props.tagCount === 1 ? "160px" : "0px");
const DecorativeImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-5"
})(_templateObject5(), lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md);
const ImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-6"
})(_templateObject6());
const TaggedImageOverlay = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-7"
})(_templateObject7(), (props)=>props.mirrorY ? "flex-end;" : "flex-start;", (props)=>props.mirrorY ? "80px" : "-80px", lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md, (props)=>props.mirrorY ? "flex-end" : "flex-start");
const TaggedImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-8"
})(_templateObject8());
const TaggedImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-edc59667-9"
})(_templateObject9());
const Tag = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-edc59667-10"
})(_templateObject10(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-four-virtual-15c0ed80e6/1/packages/component-content-section-variant-four/src/content-section-variant-four.tsx






const ContentSectionVariantFour = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , mirrorY =false , actionButton , introText , itemSection , decorativeImageOne , decorativeImageTwo , tagImageOne , tagImageTwo  } = param;
    const tagCount = (0,react.useMemo)(()=>{
        return Number(Boolean(tagImageOne)) + Number(Boolean(tagImageTwo));
    }, [
        tagImageOne,
        tagImageTwo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
            mirrorY: mirrorY,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        itemSection: itemSection,
                        paragraph: paragraph
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DecorativeImageContainerWrapper, {
                            mirrorY: mirrorY,
                            tagCount: tagCount,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                                        ...decorativeImageOne
                                    })
                                }),
                                decorativeImageTwo && /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                                        ...decorativeImageTwo
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TaggedImageOverlay, {
                            mirrorY: mirrorY,
                            children: [
                                tagImageOne && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaggedImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                        image: tagImageOne.jpeg,
                                        label: tagImageOne.title,
                                        link: tagImageOne.link,
                                        mirrorX: true,
                                        noIcon: true
                                    })
                                }),
                                tagImageTwo && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaggedImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                        image: tagImageTwo.jpeg,
                                        label: tagImageTwo.title,
                                        link: tagImageTwo.link,
                                        mirrorX: true,
                                        noIcon: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-four-virtual-15c0ed80e6/1/packages/component-content-section-variant-four/src/index.ts



/***/ }),

/***/ 42484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ ContentSectionVariantOne; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-one-virtual-2e8d1d81ce/1/packages/component-content-section-variant-one/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-left: auto;\n  grid-template-areas: ",
        ";\n  grid-template-columns: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    grid-template-areas: ",
        ";\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  grid-area: card;\n  @media screen and (max-width: ",
        "px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 80px 96px;\n  background-color: ",
        ";\n  box-shadow: 0px 18px 45px ",
        ";\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 24px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 48px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n\n  @media screen and (max-width: 345px) {\n    padding: 24px 16px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n  grid-area: primary;\n  img {\n    object-fit: cover !important;\n  }\n  @media screen and (max-width: 970px) {\n    min-height: 60vw;\n  }\n  @media screen and (max-width: 480px) {\n    min-height: 100vw;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f74a6b16-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, (props)=>props.mirrorY ? '"primary card"' : '"card primary"', (props)=>props.mirrorY ? "1fr 1.05fr" : "1.05fr 1fr", lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, (props)=>props.mirrorY ? '"primary"\n      "card"' : '"card"\n        "primary"');
const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f74a6b16-1"
})(_templateObject1(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const BlockCard = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f74a6b16-2"
})(_templateObject2(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.shadow.main */.rS.palette.shadow.main, lib_styles_src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.s */.k.container.minWidth.s, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const PrimaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f74a6b16-3"
})(_templateObject3());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-one-virtual-2e8d1d81ce/1/packages/component-content-section-variant-one/src/content-section-variant-one.tsx





const ContentSectionVariantOne = (param)=>{
    let { actionButton , heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , introText , maxColumns =1 , primaryImage , mirrorY =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        mirrorY: mirrorY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        maxColumns: maxColumns,
                        paragraph: paragraph
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                    ...primaryImage
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-one-virtual-2e8d1d81ce/1/packages/component-content-section-variant-one/src/index.ts



/***/ }),

/***/ 11473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ ContentSectionVariantSix; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-six-virtual-ba430bdf6d/1/packages/component-content-section-variant-six/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  justify-content: ",
        ";\n  padding: 213px 136px;\n  margin-right: auto;\n  margin-left: auto;\n  transition: padding 200ms;\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 24px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 48px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    padding: 48px 0px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: block;\n  max-width: 800px;\n  padding: 80px 96px 88px;\n  background-color: ",
        ";\n  filter: drop-shadow(0px 18px 45px rgba(0, 0, 0, 0.09));\n  @media screen and (max-width: ",
        "px) {\n    padding: 48px 32px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  max-width: 1616px;\n  height: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  inset: 0;\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2cf4012-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, (props)=>props.mirrorX ? "flex-end" : "flex-start", lib_styles_src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const TextCard = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2cf4012-1"
})(_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const PrimaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2cf4012-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-six-virtual-ba430bdf6d/1/packages/component-content-section-variant-six/src/content-section-variant-six.tsx





const ContentSectionVariantSix = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , mirrorX =false , introText , primaryImage , actionButton , isTopContent =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                    ...primaryImage,
                    priority: isTopContent
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                mirrorX: mirrorX,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingSize: isTopContent ? 1 : 2,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        maxColumns: 1,
                        paragraph: paragraph
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-six-virtual-ba430bdf6d/1/packages/component-content-section-variant-six/src/index.ts



/***/ }),

/***/ 99670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ ContentSectionVariantThree; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-three-virtual-19d885276b/1/packages/component-content-section-variant-three/src/styles.ts
/* stylelint-disable named-grid-areas-no-invalid */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  align-items: center;\n  margin-top: -48px;\n  grid-gap: 129px;\n  grid-template-areas: ",
        ";\n  grid-template-columns: ",
        ";\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 24px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 48px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    margin-top: unset;\n    grid-gap: 48px;\n    grid-template-areas: ",
        ";\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  height: 100vh;\n  max-height: 340px !important;\n  span {\n    position: relative;\n    height: 100% !important;\n  }\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: decorativea;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: decorativeb;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: decorativec;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: textblock;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  height: 100%;\n  max-height: 688px;\n  align-items: center;\n  grid-area: images;\n  grid-gap: 8px;\n  grid-template-areas: ",
        ";\n  grid-template-rows: ",
        ";\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}



const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3c86f2b-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const BlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3c86f2b-1"
})(_templateObject1());
const Block = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3c86f2b-2"
})(_templateObject2(), (props)=>props.hasDecorativeImage && props.mirrorY ? '"images textblock"' : '"textblock images"', (props)=>props.hasDecorativeImage ? "1fr 1fr" : "none", lib_styles_src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, (props)=>props.hasDecorativeImage && props.mirrorY ? '"images"\n    "textblock"' : '"textblock"\n    "images"');
const DecorativeImageWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3c86f2b-3"
})(_templateObject3());
const DecorativeImageAContainer = (0,styled_components_browser_cjs["default"])(DecorativeImageWrapper).withConfig({
    componentId: "sc-3c86f2b-4"
})(_templateObject4());
const DecorativeImageBContainer = (0,styled_components_browser_cjs["default"])(DecorativeImageWrapper).withConfig({
    componentId: "sc-3c86f2b-5"
})(_templateObject5());
const DecorativeImageCContainer = (0,styled_components_browser_cjs["default"])(DecorativeImageWrapper).withConfig({
    componentId: "sc-3c86f2b-6"
})(_templateObject6());
const TextBlock = (0,styled_components_browser_cjs["default"])(component_text_block_variant_one_src/* TextBlockVariantOne */.p).withConfig({
    componentId: "sc-3c86f2b-7"
})(_templateObject7());
const DecorativeImageContainerWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3c86f2b-8"
})(_templateObject8(), (props)=>props.imageCount === 2 ? '"decorativea"\n        "decorativeb"' : props.imageCount === 3 ? '"decorativea decorativea"\n        "decorativeb decorativec"' : '"decorativea"', (props)=>props.imageCount === 2 || props.imageCount === 3 ? "2fr" : "1fr");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-three-virtual-19d885276b/1/packages/component-content-section-variant-three/src/content-section-variant-three.tsx




const ContentSectionVariantThree = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , maxColumns =1 , mirrorY =false , decorativeImageOne , decorativeImageTwo , decorativeImageThree , introText , actionButton  } = param;
    const decorativeImageCount = Number(Boolean(decorativeImageOne)) + Number(Boolean(decorativeImageTwo)) + Number(Boolean(decorativeImageThree));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                hasDecorativeImage: decorativeImageCount > 0,
                mirrorY: mirrorY,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock, {
                        buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                        buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                        heading: heading,
                        headingDecoration: headingDecoration,
                        headingUnderlineColor: headingUnderlineColor,
                        introText: introText,
                        maxColumns: maxColumns,
                        paragraph: paragraph
                    }),
                    decorativeImageCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DecorativeImageContainerWrapper, {
                        imageCount: decorativeImageCount,
                        mirrorY: mirrorY,
                        children: [
                            decorativeImageOne ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageAContainer, {
                                imageCount: decorativeImageCount,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                    ...decorativeImageOne
                                })
                            }) : null,
                            decorativeImageTwo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageBContainer, {
                                imageCount: decorativeImageCount,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                    ...decorativeImageTwo
                                })
                            }) : null,
                            decorativeImageThree ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeImageCContainer, {
                                imageCount: decorativeImageCount,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                    ...decorativeImageThree
                                })
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-three-virtual-19d885276b/1/packages/component-content-section-variant-three/src/index.ts



/***/ }),

/***/ 79463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ ContentSectionVariantTwo; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-two-virtual-15163bdbdb/1/packages/component-content-section-variant-two/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-bottom: 100px;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 112px;\n  margin-bottom: -330px;\n  margin-left: 112px;\n  transform: translate3d(0, -230px, 0);\n  @media screen and (max-width: ",
        "px) {\n    top: 120px;\n    margin-right: 24px;\n    margin-bottom: 24px;\n    margin-left: 24px;\n    transform: translate3d(0, 0, 0);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  align-items: center;\n  padding: 96px 112px;\n  background-color: ",
        ";\n  box-shadow: 0px 18px 45px ",
        ";\n  grid-gap: 16px;\n  grid-template-columns: ",
        ";\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 24px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 48px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    grid-template-columns: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 40vh;\n  max-height: 616px;\n  aspect-ratio: ",
        " / ",
        ";\n  img {\n    width: 100% !important;\n    height: 100% !important;\n    max-height: 616px;\n    object-fit: cover !important;\n  }\n  @media screen and (max-width: ",
        "px) {\n    position: absolute;\n    max-height: 480px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  height: 100%;\n  align-items: center;\n  grid-gap: 8px;\n  grid-template-rows: repeat(",
        ", 1fr);\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-1"
})(_templateObject1(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const BlockCard = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-2"
})(_templateObject2(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.shadow.main */.rS.palette.shadow.main, (props)=>props.hasDecorativeImage ? "1fr 1fr" : "none", lib_styles_src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.s */.k.container.minWidth.s, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, (props)=>props.hasDecorativeImage ? "1fr" : "none");
const PrimaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-3"
})(_templateObject3(), (props)=>props.width, (props)=>props.height, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const SecondaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-4"
})(_templateObject4());
const SecondaryImageContainerWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-80914d8b-5"
})(_templateObject5(), (props)=>props.imageCount.toString());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-two-virtual-15163bdbdb/1/packages/component-content-section-variant-two/src/content-section-variant-two.tsx






const ContentSectionVariantTwo = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , introText , headingDecoration , maxColumns =1 , actionButton , primaryImage , decorativeImageOne , decorativeImageTwo , decorativeImageThree  } = param;
    const decorativeImageCount = (0,react.useMemo)(()=>{
        return Number(Boolean(decorativeImageOne)) + Number(Boolean(decorativeImageTwo)) + Number(Boolean(decorativeImageThree));
    }, [
        decorativeImageOne,
        decorativeImageThree,
        decorativeImageTwo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryImageContainer, {
                height: primaryImage.height,
                width: primaryImage.width,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                    ...primaryImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockCard, {
                    hasDecorativeImage: decorativeImageCount > 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                            buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                            buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                            heading: heading,
                            headingDecoration: headingDecoration,
                            headingUnderlineColor: headingUnderlineColor,
                            introText: introText,
                            maxColumns: maxColumns,
                            paragraph: paragraph
                        }),
                        decorativeImageCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryImageContainerWrapper, {
                            imageCount: decorativeImageCount,
                            children: [
                                decorativeImageOne ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...decorativeImageOne
                                    })
                                }) : null,
                                decorativeImageTwo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...decorativeImageTwo
                                    })
                                }) : null,
                                decorativeImageThree ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DatoImage */.jt, {
                                        ...decorativeImageThree
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-two-virtual-15163bdbdb/1/packages/component-content-section-variant-two/src/index.ts



/***/ }),

/***/ 86165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ ContentSectionVariantSeven; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-block-image-link-virtual-033cecb541/1/packages/component-block-image-link/src/index.ts + 2 modules
var src = __webpack_require__(30536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var component_dato_image_src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-seven-virtual-461dbe8dea/1/packages/component-content-section-variant-seven/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  margin-right: auto;\n  margin-left: auto;\n  @media screen and (max-width: ",
        "px) {\n    display: block;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        "px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  max-width: 600px;\n  margin-top: 60px;\n  margin-left: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-top: none;\n    margin-left: unset;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  left: ",
        ";\n  width: 125%;\n  height: 630px;\n  img {\n    width: 100%;\n    max-width: 59%;\n    max-height: 630px;\n    object-fit: cover !important;\n  }\n  @media screen and (max-width: ",
        "px) {\n    overflow: hidden;\n    width: 100%;\n    max-height: 400px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  max-width: 700px;\n  flex-direction: column;\n  align-content: flex-start;\n  margin-top: 56px;\n  gap: 23px;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-content: flex-start;\n  gap: 16px;\n  @media screen and (max-width: 545px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 60px;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    margin-top: 0;\n    margin-left: 0;\n    > * {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    > * {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    > * {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 545px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: -66px;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    margin-top: 0px;\n    > * {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 545px) {\n    display: none;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}


const SectionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, (props)=>props.mirrorY ? "row-reverse" : "row", lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-1"
})(_templateObject1());
const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-2"
})(_templateObject2(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const BlockCard = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-3"
})(_templateObject3(), (props)=>props.mirrorY ? "min(128px, 30%)" : "unset", lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const PrimaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-4"
})(_templateObject4(), (props)=>props.mirrorY ? "-20%" : "0", lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const MinicardContainerWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-5"
})(_templateObject5(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const MiniCardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-6"
})(_templateObject6());
const CardOne = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-7"
})(_templateObject7(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const CardTwo = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-8"
})(_templateObject8(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const CardThree = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-9"
})(_templateObject9(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const CardFour = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-512408b3-10"
})(_templateObject10(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-seven-virtual-461dbe8dea/1/packages/component-content-section-variant-seven/src/content-section-variant-seven.tsx








const ContentSectionVariantSeven = (param)=>{
    let { heading , paragraph , headingUnderlineColor ="blueLine" , headingDecoration , introText , maxColumns =1 , actionButton , cardOneLabel , cardOneImage , cardOneLink , cardTwoLabel , cardTwoImage , cardTwoLink , cardThreeLabel , cardThreeImage , cardThreeLink , cardFourLabel , cardFourImage , cardFourLink , mirrorY =false , primaryImage  } = param;
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        mirrorY: mirrorY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryImageContainer, {
                        mirrorY: mirrorY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                            ...primaryImage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard, {
                        mirrorY: mirrorY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                            buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                            buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                            heading: heading,
                            headingDecoration: headingDecoration,
                            headingUnderlineColor: headingUnderlineColor,
                            introText: introText,
                            maxColumns: maxColumns,
                            paragraph: paragraph
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MinicardContainerWrapper, {
                mirrorY: mirrorY,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniCardContainer, {
                        children: [
                            cardOneImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardOne, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                    image: cardOneImage,
                                    label: cardOneLabel !== null && cardOneLabel !== void 0 ? cardOneLabel : "",
                                    link: cardOneLink !== null && cardOneLink !== void 0 ? cardOneLink : "#",
                                    mirrorX: true,
                                    size: width < lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? "small" : width < lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md ? "large" : "medium"
                                })
                            }),
                            cardTwoImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTwo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                    image: cardTwoImage,
                                    label: cardTwoLabel !== null && cardTwoLabel !== void 0 ? cardTwoLabel : "",
                                    link: cardTwoLink !== null && cardTwoLink !== void 0 ? cardTwoLink : "#",
                                    mirrorX: true,
                                    size: width < lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? "small" : width < lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md ? "large" : "medium"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniCardContainer, {
                        children: [
                            cardThreeImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardThree, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                    image: cardThreeImage,
                                    label: cardThreeLabel !== null && cardThreeLabel !== void 0 ? cardThreeLabel : "",
                                    link: cardThreeLink !== null && cardThreeLink !== void 0 ? cardThreeLink : "#",
                                    mirrorX: true,
                                    size: width < lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? "small" : width < lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md ? "large" : "medium"
                                })
                            }),
                            cardFourImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFour, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BlockImageLink */.N, {
                                    image: cardFourImage,
                                    label: cardFourLabel !== null && cardFourLabel !== void 0 ? cardFourLabel : "",
                                    link: cardFourLink !== null && cardFourLink !== void 0 ? cardFourLink : "#",
                                    mirrorX: true,
                                    size: width < lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? "small" : width < lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md ? "large" : "medium"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-seven-virtual-461dbe8dea/1/packages/component-content-section-variant-seven/src/index.ts



/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ ContentSectionFiles; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/index.ts + 10 modules
var src = __webpack_require__(95967);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../packages/component-content-section-files/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8126b293-0"
})(_templateObject());

;// CONCATENATED MODULE: ../../packages/component-content-section-files/src/component-content-section-files.tsx





const ContentSectionFiles = (param)=>{
    let { tabCollection  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* CardContentTabs */.e, {
            tabCollection: tabCollection
        })
    });
};
ContentSectionFiles.Item = src/* KeyValueFields */.U;

;// CONCATENATED MODULE: ../../packages/component-content-section-files/src/index.ts



/***/ })

}]);